'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  auth: {
    activate: {
      meta_title: 'Caligram - Activation',
      title: 'New Account',
      submit: 'Submit',
      errors: {
        account_not_found: 'Account not found.',
        already_activated: 'This account is already activated.',
        default: 'An error has occurred.'
      }
    },
    form: {
      code: 'Code',
      email: 'Email',
      name: 'Name',
      password: 'Password',
      choose_password: 'Choose a password'
    },
    login: {
      forget_password: 'Forgot password',
      meta_title: 'Caligram - Connection',
      new_account: 'Create a new account',
      please_wait: 'Successfully connected. Redirecting...',
      submit: 'Connection',
      title: 'Connection',
      unauthorizedErrorMessage: 'Unknown Username or password',
      badRequestErrorMessage: 'Missing Username or password.',
      serverErrorMessage: 'System error. Please try again in a few minutes.'
    },
    loginCode: {
      loading: 'connection...',
      meta_title: 'Caligram - Connection',
      submit: 'Connection',
      title: 'Connection'
    },
    register: {
      meta_title: 'Caligram - Create an account',
      title: 'Create an account',
      success: 'Account created succesfully. You can now log in.',
      buttons: {
        go_login: 'Go to log in page'
      },
      submit: 'CREATE ACCOUNT'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/auth.js
// module id = 2281
// module chunks = 0